<template lang="html">
  <div v-if="controlFile" class="admin-files-wrapper">
    <div class="title">
      <span>{{ $t('franchise.franchise') }}</span>
      <!-- <locale-picker /> -->
    </div>
    <div class="table-wrapper">
      <table>
        <thead>
          <tr>
            <td>{{$t('competitions.modal.nameDocuments')}}</td>
            <td style="width: 150px;"></td>
            <td style="width: 150px;"></td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="document in documents" :key="document.frd_id">
            <td>
              {{ document.frd_name }}
            </td>
             <td>
              <!-- <div @click="openEditModal(document)" class="btn">
                {{ $t('competitions.main.edit') }}
              </div> -->
            </td> 
            <td>
              <div @click="openConfirmationModal(document)" class="btn">
                {{ $t('competitions.main.delete') }}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="action-wrapper">
      <div @click="openNewModal()" class="btn">
        {{ $t('competitions.main.addDocument') }}
      </div>
    </div>
  </div>
</template>

<script>
import LocalePicker from '@/components/header/LocalePicker.vue'
import { api } from '@/api'
import eventBus from '@/shared/eventBus.js'
export default {
  name: 'adminFiles',
  components: {
    LocalePicker
  },
  data () {
    return {
      documents: [],
      controlFile: true
    }
  },
  mounted () {
    this.getDocuments()
    
  },
  activated(){
    // this.$i18n.locale = 'en'
  },
  methods: {
    getDocuments () {
      api.getListFranchise().then(res => {
        this.documents = res.data.data
      })
    },
    openConfirmationModal (document) {
      let modalData = {
        title: this.$t('competitions.main.deleteThis')+' ' + document.frd_name,
        ok: () => {
          this.deleteDocument(document)
        }
      }
      let params = {
        modalData: modalData,
        component: 'confirmModal'
      }
      eventBus.$emit('openModal', params)
    },
    deleteDocument (document) {
      let params = {
        id: document.frd_id
      }
      api
        .deleteDocumentFranchise(params)
        .then(res => {
          this.getDocuments()
          this.$toast.success(this.$t('competitions.main.success'), {
            duration: 8000
          })
        })
        .catch(e => {
          console.log(e)
          this.$toast.error(this.$t('competitions.tr.error'), {
            duration: 8000
          })
        })
    },
    openEditModal (document) {
        let help = { 
            doc_id:document.frd_id, 
            doc_name: document.frd_name
        }
      let modalData = {
        title: this.$t('competitions.main.edit')+' '+ document.frd_name,
        document: help,
        ok: () => {
          this.editDocument(help)
        }
      }
      let params = {
        modalData: modalData,
        component: 'editDocument'
      }
      eventBus.$emit('openModal', params)
    },
    editDocument (document) {
        console.log(document)
       
      let params = {
        frd_name: document.doc_name,
        frd_id: document.doc_id
      }
      api
        .editDocumentFranchise(params)
        .then(res => {
          this.getDocuments()
          this.$toast.success(this.$t('competitions.main.success'), {
            duration: 8000
          })
        })
        .catch(e => {
          console.log(e)
          this.$toast.error(this.$t('competitions.tr.error'), {
            duration: 8000
          })
        })
    },
    openNewModal () {
      let modalData = {
        title: this.$t('competitions.main.addDocument'),
        ok: document => {
          this.addDocument(document)
        }
      }
      let params = {
        modalData: modalData,
        component: 'addDocument'
      }
      eventBus.$emit('openModal', params)
    },
    addDocument (document) {
      let params = new FormData()
      params.append('frd_document',document['doc_document'])
      params.append('frd_name',document['doc_name'])
    //   for (var variable in document) {
    //     if (document.hasOwnProperty(variable)) {
    //       params.append(variable, document[variable])
    //       console.log(variable +' '+document[variable] )
    //     }
    //   }
    
      api
        .addDocumentFranchise(params)
        .then(res => {
          this.getDocuments()
          this.$toast.success(this.$t('competitions.main.success'), {
            duration: 8000
          })
        })
        .catch(e => {
          console.log(e)
          this.$toast.error(this.$t('competitions.tr.error'), {
            duration: 8000
          })
        })
    }
  },
  watch: {
    '$route.params.lang': {
      handler: function () {
        this.getDocuments()
      }
    },
    '$i18n.locale': {
      handler (newLocale, oldLocale) {
        if (newLocale !== oldLocale) {
          if (this.$route.params.hasOwnProperty('lang')) {
            this.controlFile = false
            setTimeout(() => {
              this.controlFile = true
            }, 10)
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.admin-files-wrapper {
  padding-left: 40px;
  box-sizing: border-box;
  @import '@/assets/scss/btnStyles.scss';
  @import '@/assets/scss/tableStyles.scss';
  height: 100%;
  position: relative;

  .table-wrapper {
    height: calc(100% - 160px);
    overflow: auto;
    margin-bottom: 20px;
  }

  .title {
    margin-bottom: 25px;
    font-size: 21px;
    color: $text-color;
    text-align: left;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
  table {
    margin-bottom: 20px;
  }
  .action-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
  }
}
</style>
